import { Injectable, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { Observable, filter, map, take } from 'rxjs';
import { JenzPermissions } from '../constants/permissions.constant';
import { LocalStorageClass } from '../helpers/local-storage-helper';
import { AppInitService } from '../services/shared/app-init.service';
import { ToastService } from '../services/shared/toast.service';
import { UserService } from '../services/shared/user.service';

@Injectable({ providedIn: 'root' })
export class AdminProjectGuard {
  private readonly router = inject(Router);
  private readonly userService = inject(UserService);
  private readonly appInit = inject(AppInitService);
  private readonly toast = inject(ToastService);
  private readonly initialized$ = toObservable(this.appInit.initialized);

  canActivate(): Observable<boolean> | boolean {
    const token = LocalStorageClass.retrieveTokenFromStorage();

    if (!token?.length) {
      this.router.navigate(['login']).then(() => window.location.reload());
      return false;
    }

    if (this.userService.currentUser) return this.checkPermission();

    return this.initialized$.pipe(
      filter((initialized) => initialized),
      take(1),
      map(() => this.checkPermission()),
    );
  }

  private checkPermission(): boolean {
    const hasPermission = !this.userService.userRoles.includes(JenzPermissions.User);

    if (!hasPermission) {
      this.toast.error("You don't have permission to view this page");
      this.router.navigate(['']);
      return false;
    }

    return true;
  }
}
